import { z } from "zod";

export const OBSERVACAO_MAX = 500;

// Hora de início opcional: vazio é "sem hora definida".
export const horaInicioSchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Use o formato HH:MM")
  .or(z.literal(""));

export const plantaoSchema = z.object({
  vinculoId: z.coerce.number({ invalid_type_error: "Escolha o vínculo" }).positive("Escolha o vínculo"),
  data: z.string().min(1, "Informe a data do plantão"),
  horas: z.coerce.number({ invalid_type_error: "Informe as horas" }).positive("Deve ser maior que zero").max(48, "Máximo de 48 horas"),
  valor: z.coerce.number({ invalid_type_error: "Informe o valor" }).positive("O valor deve ser maior que zero"),
  horaInicio: horaInicioSchema.default(""),
  observacao: z.string().max(OBSERVACAO_MAX, `Até ${OBSERVACAO_MAX} caracteres`).default(""),
  importante: z.boolean().default(false),
});

// Edição completa (tela Recebíveis: data/horas/valor de um plantão já existente) — mesmas
// regras de plantaoSchema, só sem vinculoId (o vínculo não é editável).
export const editarPlantaoSchema = plantaoSchema.omit({ vinculoId: true });

// Reagendamento (tela Calendário): só a data muda.
export const reagendarPlantaoSchema = editarPlantaoSchema.pick({ data: true });
